var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-radio-group",class:{'is-inline': _vm.inline}},[_c('div',{staticClass:"pp-radio__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }